import { guideSteps } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div data-reveal className="lg:col-span-5">
            <SectionHeading
              index="05"
              eyebrow="访问指南"
              title="入口打不开？四步就能重新找到"
              desc="地址会变、线路会波动，但只要掌握这套方法，任何时候都能重新定位到可用的撸撸射入口。"
            />

            <div className="mt-8 overflow-hidden rounded-lg border border-background-300 bg-background-100">
              <div className="relative h-[200px] w-full sm:h-[240px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20a%20minimal%20workspace%20on%20cream%20paper%20background%2C%20open%20notebook%20and%20compass%20with%20amber%20and%20vermilion%20accents%2C%20soft%20natural%20window%20light%2C%20magazine%20illustration%20style%2C%20elegant%20negative%20space%2C%20high%20detail%2C%20cohesive%20warm%20color%20palette&width=1200&height=800&seq=lulu-guide-01&orientation=landscape"
                  alt="撸撸射入口访问指南示意图"
                  title="撸撸射访问指南 · 快速找到可用入口"
                  className="h-full w-full object-top object-cover"
                />
              </div>
              <div className="flex items-center gap-3 p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                  <i className="ri-lightbulb-flash-line text-xl" aria-hidden="true"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-600">
                  小提示：同时保存 2 条以上线路，主站拥堵时切换更顺畅。
                </p>
              </div>
            </div>
          </div>

          <div data-reveal className="lg:col-span-7">
            <div className="flex flex-col gap-4">
              {guideSteps.map((step) => (
                <div
                  key={step.step}
                  className="flex items-start gap-5 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-400 md:p-6"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-foreground-950 font-heading text-lg font-black text-primary-300">
                    {step.step}
                  </span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <i className={`${step.icon} text-base text-accent-600`} aria-hidden="true"></i>
                      <h3 className="font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
                    </div>
                    <p className="mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}